import {computed, inject, Injectable, signal} from '@angular/core';
import {environment} from '@epg-apps/cdh-environments';
import {HttpClient} from '@angular/common/http';
import {ContactDto, ContactState, PageDto} from '@epg-apps/cdh-models';
import {take} from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CdhContactApiService {
  private static readonly CONTACT_CDH_API = environment.cdhApi + 'contacts';
  http = inject(HttpClient);

  private readonly contactsState = signal<ContactState>({
    contactPage: undefined,
    isLoading: false,
  });

  mostRecentPageable = computed(
    () => this.contactsState().contactPage!.pageable,
  );
  selectedCustomerContacts = computed(
    () => this.contactsState().contactPage?.content ?? [],
  );

  public loadContactsPage(customerId = '', pageNumber = 0, pageSize = 10) {
    this.getContactsByCustomerId(customerId, pageNumber, pageSize)
      .pipe(take(1))
      .subscribe((contactsPage) => {
        this.setContacts(contactsPage);
      });
  }

  public getContactsByCustomerId(
    customerId: string,
    pageNumber = 0,
    pageSize = 10,
  ) {
    const headerOptions = {
      params: {
        customerId: customerId,
        pageNumber: pageNumber,
        pageSize: pageSize,
      },
    };
    return this.http.get<PageDto<ContactDto>>(
      CdhContactApiService.CONTACT_CDH_API,
      headerOptions,
    );
  }

  public setContacts(contacts: PageDto<ContactDto>) {
    this.contactsState.update((state) => ({
      ...state,
      contactPage: contacts,
    }));
  }
}
